export const useGetToken = () => {
  // check if the token is expired and if so logout the user and clear the local storage.
  return localStorage.getItem('AUTH_TOKEN') as string;
};
